export const breakpoints = {
  "breakpoint-sm": {
    maxWidth: 490,
  },
  "breakpoint-md": {
    maxWidth: 768,
  },
  "breakpoint-lg": {
    maxWidth: 1024,
  },
  "breakpoint-xl": {
    maxWidth: 1440,
  },
};

export type CascadiaBreakpointTypes = typeof breakpoints;
export type CascadiaBreakpoint = keyof CascadiaBreakpointTypes;
